// extracted by mini-css-extract-plugin
export var collage = "collageStyles-module__collage___bCPn4";
export var collageCol = "collageStyles-module__collageCol___ETGQe";
export var collageImage = "collageStyles-module__collageImage___TelT8";
export var endAlign = "collageStyles-module__endAlign___nb6KT";
export var image0 = "collageStyles-module__image0___TjkZY";
export var image1 = "collageStyles-module__image1___AXW4F";
export var image2 = "collageStyles-module__image2___sRS6_";
export var image3 = "collageStyles-module__image3___mcuum";
export var imageCaption = "collageStyles-module__imageCaption___XG4yf";
export var imageCaptionBottom = "collageStyles-module__imageCaptionBottom___N_b10";
export var imageCaptionTop = "collageStyles-module__imageCaptionTop___DKX_Z";
export var imageContainer = "collageStyles-module__imageContainer___O_mmB";